<script>

    import {createEventDispatcher, onDestroy} from "svelte";
    import {get} from "svelte/store";
    import QrCode from "svelte-qrcode";
    import CartItem from "./CartItem.svelte";
    import {cartInfoStore, cartItemsStore, cartTotalStore, confirmOrder} from "./cart-store.js";
    import {publishConfigStore, tenantKeyStore} from "../core/app-store.js";
    import {scrollToElementId} from "../core/utils.js";
    import {orderConfigStore} from "../orders/orders-store.js";
    import {closeCartScreen, openOrderScreen, screensStore} from "../core/screens-manager.js";
    import Button from "../components/Button.svelte";
    import {reachGoal} from "../core/ecommerce.js";
    import {deliveryOpenStore, checkOpenState} from "../core/time.js";

    const orderConfig = get(orderConfigStore);

    const dispatch = createEventDispatcher();

    export let opened = false;
    export let showTotal = true;

    function closeScreen () {
        dispatch('close');
    }

    function confirm (items) {

        confirmOrder(items);

        openOrderScreen();

        reachGoal('OPEN_ORDER_FORM');

        // setTimeout(() => {scrollToElementId('order-qr', 'cart');}, 300);
    }

    const storeSubscriptions = [
        screensStore.subscribe(x => {
            if (x.cartOpened) {
                checkOpenState();
            }
        })
    ];

    onDestroy(() => {
        for (let i = 0; i < storeSubscriptions.length; i++){
            storeSubscriptions[i]();
        }
    });

</script>

<style>

    .screen-header svg {
        color: var(--screen-text-color);
    }
    .screen-header small {
        opacity: .7;
    }

    ul {
        display: flex;
        flex-direction: column;
        gap: 1.25rem;
    }
    li {}
    li.no-data {
        text-align: center;
        padding: 2rem 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1rem;
    }
    li.no-data button {
        padding: 0.75rem 1.5rem;
        border: none;
        border-radius: 1.5rem;
        font-size: inherit;
        font-family: inherit;
        font-weight: 600;
        letter-spacing: .5px;
        color: var(--price-item-font-color);
        background: var(--success-bg-color);
        transition: background-color .2s ease-in-out;
        box-shadow: 0 6px 9px 4px rgb(0 0 0 / 8%);
    }

    li.separator {
        border-bottom: 1px solid var(--cart-items-separator);
    }

    .delivery-block {
        text-align: right;
        font-weight: 400;
    }
    .total-block {
        font-size: var(--fs-150);
        font-weight: 600;
        display: flex;
        justify-content: end;
        padding: 5px 0;
    }
    .min-order-note {
        text-align: center;
    }
    .min-order-warning {
        line-height: 1.25;
        background: var(--cart-min-order-warning-bg);
        padding: .5rem .8rem;
        border-radius: .5rem;
    }
    .order-qr {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background: var(--bg-second-color);
        margin-top: -2.5rem;
        z-index: 0;
        padding: 2rem 1rem;
        border-radius: 2rem;
    }
    .order-qr p {
        text-align: center;
    }
</style>

{#if (opened)}

    <div class="layer-cart screen-backdrop"></div>
    <div class="layer-cart screen-content slide-up-animation--centered">
        <div class="screen-header">
            <span>
                <h1>Моя корзина</h1>
                <small>{ $cartTotalStore.count } блюд(а)</small>
            </span>

            <button class="screen-close-button pointer" on:click={closeScreen}>
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-Cross"><path d="M20 20L4 4m16 0L4 20"/></svg>
            </button>
        </div>

        <ul>
            {#each $cartItemsStore as item}
            <li>
                <CartItem item={item}
                          publishConfig={$publishConfigStore}
                          tenantKey={$tenantKeyStore}>
                </CartItem>
            </li>
            <li class="separator"></li>
            {/each}

            {#if ($cartItemsStore.length === 0)}
                <li class="no-data">
                    <span>В заказе нет позиций</span>
                    <button class="pointer" on:click={closeScreen}>Открыть меню</button>
                </li>
            {/if}
        </ul>

        {#if ($cartItemsStore.length > 0 && showTotal)}
            <div>
                {#if ($orderConfigStore.enabled && $orderConfigStore.deliveryPrice)}
                <div class="delivery-block">
                    Стоимость доставки <strong>${$orderConfigStore.deliveryPrice} { $publishConfigStore.currency }</strong>
                </div>
                {/if}
                <div class="total-block">
                    <span>Итого:&nbsp;</span>
                    <strong>{ $cartTotalStore?.sum }&nbsp;{#if ($publishConfigStore?.currency)}{ $publishConfigStore.currency }{/if}</strong>
                </div>
            </div>
        {/if}

        <div class="flex-fill"></div>

        <div class="screen-footer">
            {#if ($cartItemsStore.length > 0 && $orderConfigStore.enabled)}

                {#if ($cartTotalStore?.sum < ($orderConfigStore.minOrder || 0) ) }
                    <div class="min-order-warning">
                        Сумма вашего заказа ниже минимальной. Для оформления заказа вам необходимо добавить в корзину товары на сумму не менее <strong>{$orderConfigStore.minOrder} {$publishConfigStore.currency}</strong>.
                    </div>
                {/if}

                {#if ($deliveryOpenStore.isOpen === false && $deliveryOpenStore.nextOpenDateStr && $orderConfigStore.outOfOpenHours !== 'ALLOW')}
                    {#if ($orderConfigStore.outOfOpenHours === 'ALLOW_NOTIFY')}
                        <div class="min-order-note">
                            К сожалению сейчас служба доставки не работает, мы примем ваш заказ и обработаем его сразу же как только она откроется.
                        </div>
                    {/if}
                    {#if ($deliveryOpenStore.waitMinutes <= 60)}
                        <div class="min-order-note">Доставка откроется через { $deliveryOpenStore.waitMinutes } мин.</div>
                    {:else}
                        <div class="min-order-note">Доставка работает с { $deliveryOpenStore.nextOpenDateStr }</div>
                    {/if}
                {/if}

                <Button label="{$orderConfigStore.placeOrderButtonText || 'Оформить заказ'}"
                        icon="bag"
                        type="primary"
                        disabled="{$cartTotalStore?.sum < ($orderConfigStore.minOrder || 0) || ($deliveryOpenStore.isOpen === false && $orderConfigStore.outOfOpenHours === 'NOT_ALLOW')}"
                        on:clicked={confirm($cartItemsStore)}>
                </Button>

            {/if}

            <!-- <Button label="Мои предыдущие заказы" type="secondary"></Button>-->

            {#if ($cartInfoStore.orderData)}

                <div class="order-qr" style="display:none;">
                    <p>Покажите этот QR-код официанту чтобы он принял заказ</p>
                    <div id="order-qr">
                        <QrCode value="https://app.digital-menu.ru/o/{$tenantKeyStore}/{$cartInfoStore.orderData}" />
                    </div>
                </div>
            {/if}


        </div>

    </div>
{/if}
